'use client';

import { useMemo } from 'react';

import { useSession as useNextSession } from 'next-auth/react';


export const useSession = () => {
  const session = useNextSession();

  return useMemo(() => {
    return {
      session,
      isPending: session.status === 'loading',
      user: session.data?.user,
      token: session.data?.strapiToken,
    };
  }, [session]);
};
